export const canRedirectAfterSignin = (pathname: string) => {
  if (pathname === "/") return false;

  return !["http", "sign_in", "sign_up", ""].includes(pathname);
};
